import {
  CFormCheck,
  CSpinner,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { useQueryClient, useMutation } from "react-query";
import { useToast } from "../../../hooks/useToast";
import { useCookie } from "../../../hooks/useCookie";
import apiService from "../../../service/apiService";
import { DELETE_ACTIONS } from "../../../config/constants";
import { general } from "../../../locales/general";
import { colors } from "../../../config/theme";
import EditIcon from "../../../components/icons/EditIcon";
import DeleteIcon from "../../../components/icons/DeleteIcon";
import PromptModal from "../../../components/modals/PromptModal";
import { Link } from "react-router-dom";

function TableBodyRowContent({
  specialTranslation,
  deletedList,
}: {
  specialTranslation: SpecialTranslation;
  deletedList: React.Dispatch<BulkDeleteActions>;
}) {
  const [isChecked, setIsChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { toastSuccess, toastError } = useToast();
  const { token } = useCookie("vToken");
  const queryClient = useQueryClient();

  const deleteSpecialTranslation = useMutation((id: string) => {
    return apiService.MakeDeleteRequest(`special-translations/${id}`, token);
  });

  useEffect(() => {
    if (isChecked) {
      deletedList({ type: DELETE_ACTIONS.ADD, id: specialTranslation.id });
    } else {
      deletedList({ type: DELETE_ACTIONS.REMOVE, id: specialTranslation.id });
    }
  }, [deletedList, isChecked, specialTranslation.id]);

  const removeSpecialTranslation = () => {
    deleteSpecialTranslation.mutate(specialTranslation.id, {
      onError(error) {
        console.log(error);
        toastError(general.fr.message.operationFailed);
      },
      onSuccess() {
        toastSuccess(general.fr.message.partnerDeleted);
        queryClient.invalidateQueries("getAllTranslations");
      },
    });
  };

  return (
    <CTableRow
      style={{
        borderLeft: isChecked ? `3px solid ${colors.primary}` : "",
        width: "100%",
        position: "relative",
      }}
    >
      <CTableDataCell className=" text-capitalize text-sm">
        <div className="d-flex align-items-center gap-3">
          <CFormCheck
            id="flexCheckDefault"
            label=""
            defaultChecked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
            color={colors.yellow}
          />
          <img
            src={specialTranslation.special?.image}
            alt=""
            width={30}
            height={30}
            style={{ borderRadius: "100%" }}
          />
          <div>{specialTranslation.special?.title}</div>
        </div>
      </CTableDataCell>
      <CTableDataCell className="text-capitalize text-sm">
        <span className="ms-3">{specialTranslation?.title}</span>
      </CTableDataCell>
      <CTableDataCell className="text-capitalize text-sm">
        <span className="ms-3">{specialTranslation?.lang}</span>
      </CTableDataCell>

      <CTableDataCell>
        <Link to={`/special-translations/update/${specialTranslation.id}`}>
          <EditIcon width="18" height="18" fill={colors.secondary} />
        </Link>{" "}
        <button
          className="outline-none border-0 bg-transparent"
          onClick={() => setShowModal(true)}
        >
          {deleteSpecialTranslation.isLoading ? (
            <CSpinner size="sm" />
          ) : (
            <DeleteIcon
              width="20"
              height="20"
              fill={colors.primary}
              className="ms-2"
            />
          )}
        </button>
      </CTableDataCell>
      <PromptModal
        open={showModal}
        onAccept={removeSpecialTranslation}
        onClose={() => setShowModal(false)}
      />
      {/* <SpecialTranslationModal
                onClose={() => setShowEditModal(false)}
                open={showEditModal}
                id={specialTranslation?.id}
                name={specialTranslation?.name}
                link={specialTranslation?.link}
                logo={specialTranslation?.logoImage}
            /> */}
    </CTableRow>
  );
}

interface TableProps {
  specialTranslations: SpecialTranslation[];
  specialTranslationsToBeDeleted: React.Dispatch<BulkDeleteActions>;
}

export default function SpecialTranslationsTable({
  specialTranslations,
  specialTranslationsToBeDeleted,
}: TableProps) {
  return (
    <div className="mt-3">
      <CTable responsive>
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell scope="col">Offre</CTableHeaderCell>
            <CTableHeaderCell scope="col">Titre</CTableHeaderCell>
            <CTableHeaderCell scope="col">Langue</CTableHeaderCell>
            <CTableHeaderCell scope="col"></CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {specialTranslations?.map((specialTranslation) => (
            <TableBodyRowContent
              specialTranslation={specialTranslation}
              key={specialTranslation?.id}
              deletedList={specialTranslationsToBeDeleted}
            />
          ))}{" "}
        </CTableBody>
      </CTable>
    </div>
  );
}
